
import ARRAY from "../../UTIL/ARRAY";
import { log } from "../../UTIL/LOG";

 
 
class Signal
{
    public tabs         : any;
    public listeners    : any = {};
    public broadcast    : Function = function( name:string, value?:any ){};

    constructor()
    {
        log("SIGNAL CREATED");

        if (typeof window != 'undefined' ) 
        {
            window.addEventListener('message', function(event) 
            {
                console.log('WINDOW msg received from Dart:', event.data);
            }, false );

            if( window.parent != window )
            {
                window.parent.addEventListener('message', function(event) 
                {
                    console.log('PARENT msg received from Dart:', event.data);
                }, false );

            }


        }


    }
 
    public get( name:string, callback:Function )
    {
        if( !this.listeners[name] ) this.listeners[name] = [];
        ARRAY.pushUnique( this.listeners[name], callback );
    }

    public set( name:string, value?:any )
    {
        this.broadcast?.( name, value );

        if (typeof window != 'undefined' && window.parent != window) 
        {
            window.parent.postMessage( JSON.stringify({ label:name, value:value }) );
        } 

        if( !this.listeners[name] ) return;

        for( let n in this.listeners[name] ) this.listeners[name][n]( value );
    }

    public remove( name:string, callback:Function )
    {
        if( !this.listeners[name] ) return;

        ARRAY.removeItem( this.listeners[name], callback );
    }

    public getInstance()
    {
        return new Signal();
    }
}

export default Signal;